export default function initHeaderMobileMenu() {
	const header = document.querySelector(".header");
	const burger = document.querySelector(".header__burger");
	const navigation = document.querySelector(".header__navigation");
	const mobileClose = document.querySelector(".header__mobile-close");
	const mobileOverlay = document.querySelector(".header__mobile-overlay");
	const submenuItems = navigation ? navigation.querySelectorAll(".menu-item-has-children") : [];
	const currentLinks = navigation ? navigation.querySelectorAll(".current-menu-item > a, .current_page_item > a") : [];
	const mobileQuery = window.matchMedia("(max-width: 980px)");

	const closeMobileMenu = () => {
		if (!burger || !navigation) {
			return;
		}

		burger.classList.remove("is-active");
		burger.setAttribute("aria-expanded", "false");
		navigation.classList.remove("is-open");
		document.body.classList.remove("header-menu-open");

		submenuItems.forEach((item) => {
			item.classList.remove("is-open");
		});
	};

	if (burger && navigation) {
		burger.addEventListener("click", () => {
			const isOpen = navigation.classList.toggle("is-open");

			burger.classList.toggle("is-active", isOpen);
			burger.setAttribute("aria-expanded", String(isOpen));
			document.body.classList.toggle("header-menu-open", isOpen);
		});
	}

	if (mobileClose) {
		mobileClose.addEventListener("click", closeMobileMenu);
	}

	if (mobileOverlay) {
		mobileOverlay.addEventListener("click", closeMobileMenu);
	}

	submenuItems.forEach((item) => {
		const link = item.querySelector(":scope > a");

		if (!link) {
			return;
		}

		link.addEventListener("click", (event) => {
			if (!mobileQuery.matches) {
				return;
			}

			event.preventDefault();
			item.classList.toggle("is-open");
		});
	});

	currentLinks.forEach((link) => {
		link.addEventListener("click", (event) => {
			if (mobileQuery.matches) {
				event.preventDefault();
			}
		});
	});

	document.addEventListener("click", (event) => {
		if (header && !header.contains(event.target)) {
			closeMobileMenu();
		}
	});

	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape") {
			closeMobileMenu();
		}
	});
}
